var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"anchor"},[_vm._t("default")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"popover",staticClass:"popover-container",style:({minWidth: `${_vm.containerWidth}px`})},[_vm._t("poppable")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }